import { render } from "./CloudDataExplainer.vue?vue&type=template&id=ebb21314&scoped=true&ts=true"
import script from "./CloudDataExplainer.vue?vue&type=script&lang=ts"
export * from "./CloudDataExplainer.vue?vue&type=script&lang=ts"

import "./CloudDataExplainer.vue?vue&type=style&index=0&id=ebb21314&scoped=true&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebb21314"]])

export default __exports__